import React from 'react'
import { Disclosure } from '@headlessui/react'
import { MenuIcon, XIcon } from '@heroicons/react/outline'
import logo from "../../image/logo.jpg"

const navigation = [
    { name: 'MISSION', href: '/#mission' },
    { name: 'CONTENT', href: '/#content' },
    { name: 'PORTFOLIO', href: '/Portfolio' },
    { name: 'CONTACT', href: '/#contact' },

]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}


const Header = () => {
    return (
        <Disclosure as="nav" className="">
            {({ open }) => (
                <>
                    <div className="max-w-5xl mx-auto px-2 sm:px-6 lg:px-8 " id="Navbar">
                        <div className="relative flex items-center justify-between h-16">
                            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-black  hover:text-black hover:after:text-purple-600 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-black">
                                    <span className="sr-only">Open menu</span>
                                    {open ? (
                                        <XIcon className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>
                            <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                                <div className="flex-shrink-0 flex items-center ">
                                    <img src={logo} alt="nft fabric" height={40} width={40} />
                                </div>
                                <div className="hidden sm:block sm:ml-8">
                                    <div className="flex space-x-4">
                                        {navigation.map((item) => (
                                            <a
                                                key={item.name}
                                                href={item.href}
                                                className={classNames(
                                                    'text-black  hover:text-purple-600',
                                                    'px-4 py-2 rounded-md text-xl font-bold font-custom'
                                                )}
                                            >
                                                {item.name}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="cursor-pointer absolute right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0 mt-12 h-24 w-24 md:w-40 md:h-40">
                            </div>
                        </div>
                    </div>

                    <Disclosure.Panel className="sm:hidden">
                        <div className="px-2 pt-2 pb-3 space-y-1">
                            {navigation.map((item) => (
                                <Disclosure.Button
                                    key={item.name}
                                    as="a"
                                    href={item.href}
                                    className={classNames(
                                        'text-black hover:text-black',
                                        'block px-3 py-2 rounded-md text-base font-custom '
                                    )}
                                >
                                    {item.name}
                                </Disclosure.Button>
                            ))}
                        </div>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    )
}

export default Header